<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'right-angled-triangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const base = computed({
	get: () => dimensions.value.base,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "base",
			value: value,
		});
	},
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="right-angled-triangle-base"
			:id="`${prefix}measurements-right-angled-triangle-base`"
			:name="`${prefix}measurements[dimensions][base]`"
			unit="cm"
			:label="dimensionLabel('width', 'right-angled-triangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}right-angled-triangle-base`)"
			:onBlur="() => addSizeToDataLayer('base', +base, 'right-angled-triangle')"
			v-model="base"
		/>

		<dimension-input
			inputRef="right-angled-triangle-height"
			:id="`${prefix}measurements-right-angled-triangle-height`"
			:name="`${prefix}measurements[dimensions][height]`"
			unit="cm"
			:label="dimensionLabel('height', 'right-angled-triangle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}right-angled-triangle-height`)"
			:onBlur="() => addSizeToDataLayer('height', +height, 'right-angled-triangle')"
			v-model="height"
		/>
	</shape-input-fields-wrapper>
</template>
